import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import InterestRate from "./interestRate";
import InterestRateFiscalWise from "./interestRateFiscalWise";
import OtherInterestRate from "./otherInterestRate";
import Breadcrumbs from "../../common/breadcumb";
import Loading from "../../common/loading";
import { TabTitle } from "../../common/dynamicTitle";
import Errors from "../../common/error";
import { LangContext } from "../../context/LangContext";
function Rates() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams(null);

  const [spinner, setSpinner] = useState(true);
  useEffect(() => {
    setTimeout(() => setSpinner(false), 3000);
  }, [true]);

  const pageTitle = useMemo(() => {
    switch (slug) {
      case "interest-rates":
        return nep ? "ब्याज दरहरू" : "Interest rates";
      case "fiscal-year-wise-interest":
        return nep ? "आर्थिक वर्ष अनुसार ब्याजदर" : "Fiscal year wise interest";
      case "base-rate":
        return nep ? "आधार दर" : "Base rate";
      case "interest-spread-rate":
        return nep ? "ब्याज स्प्रेड दर" : "interest spread rate";
      case "standard-tariff-of-charges":
        return nep
          ? "standard tariff of charges"
          : "standard tariff of charges";

      default:
        return slug;
    }
  }, [slug, nep]);
  TabTitle(`GMBF | ${pageTitle}`);
  if (spinner) return <Loading />;
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      {
        {
          "interest-rates": <InterestRate />,
          "fiscal-year-wise-interest": <InterestRateFiscalWise />,
          "base-rate": <OtherInterestRate />,
          "interest-spread-rate": <OtherInterestRate />,
          "standard-tariff-of-charges": <OtherInterestRate />,
        }[slug]
      }
    </>
  );
}

export default Rates;
